/// <amd-module name="VSS/Platform/RestClient/Locations" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   webplatform\web\extensions\vss-web\vss-platform\genclient.json
 */

import { IVssPageContext, IVssRestClientOptions, RestClients } from "../Context";
import { RestClientBase } from "../RestClientBase";

import * as Locations from "../Contracts/Locations";

import { ILocationsRestClient } from "VSS/Platform/RestClient/Locations.Types";

export { ILocationsRestClient } from "VSS/Platform/RestClient/Locations.Types";

class LocationsRestClient extends RestClientBase implements ILocationsRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param areaId - 
     * @param enterpriseName - 
     * @param organizationName - 
     */
    public async getResourceArea(
        areaId: string,
        enterpriseName?: string,
        organizationName?: string
        ): Promise<Locations.ResourceAreaInfo> {

        const queryValues: any = {
            enterpriseName: enterpriseName,
            organizationName: organizationName
        };

        return this.beginRequest<Locations.ResourceAreaInfo>({
            apiVersion: "4.0-preview.1",
            routeTemplate: "_apis/ResourceAreas/{areaId}",
            routeValues: {
                areaId: areaId
            },
            queryParams: queryValues
        });
    }

    /**
     * @param areaId - 
     * @param hostId - 
     */
    public async getResourceAreaByHost(
        areaId: string,
        hostId: string
        ): Promise<Locations.ResourceAreaInfo> {

        const queryValues: any = {
            hostId: hostId
        };

        return this.beginRequest<Locations.ResourceAreaInfo>({
            apiVersion: "4.0-preview.1",
            routeTemplate: "_apis/ResourceAreas/{areaId}",
            routeValues: {
                areaId: areaId
            },
            queryParams: queryValues
        });
    }

}

export const LocationsClientName = "ILocationsRestClient";

export function getLocationsClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ILocationsRestClient {
    return pageContext.getRestClient<ILocationsRestClient>(LocationsClientName, options);
}

RestClients.add(LocationsClientName, { 
    factory: LocationsRestClient
});
